"use client";
import React from "react";
import { useModalCustomerContext } from "@/context/CustomerContext";
import Image from "next/image";
const CustomerBtn = ({ className }: { className?: string }) => {
	const { isCustomerModalOpen, openModalCustomer } = useModalCustomerContext();

	return (
		<>
			<button
				onClick={openModalCustomer}
				className={`group fixed bottom-10 left-3  z-50 cursor-pointer   rounded-full   bg-white p-1 text-black    shadow-mainShadow transition-all  duration-300  hover:-translate-y-1.5  max-md:bottom-[80px] ${
					isCustomerModalOpen ? "opacity-0" : "opacity-100"
				}`}
			>
				<i className="ri-chat-smile-2-line px-2 text-[30px]"></i>
			</button>
		</>
	);
};

export default CustomerBtn;
